import { DatePipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ButtonModule, DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { ExchangeStore } from '@kr/components/exchange/exchange.store';
import { WalletCard } from '@kr/models';
import { CurrencyBalanceFormatPipe } from '@kr/pipes';
import { ClipboardService } from '@kr/services';

@Component({
  selector: 'kr-exchange-success',
  imports: [IconModule, TranslateModule, DatePipe, CurrencyBalanceFormatPipe, ButtonModule, ReactiveFormsModule],
  templateUrl: './exchange-success.component.html',
  styleUrl: './exchange-success.component.scss',
})
export class ExchangeSuccessComponent implements OnInit, OnDestroy {
  protected readonly now = Date.now();
  readonly clipboard = inject(ClipboardService);
  readonly dialogRef = inject(DialogRef);
  readonly store = inject(ExchangeStore);

  wallets = this.store.wallets();
  form = this.store.form;
  estimation = this.store.exchangeEstimate;

  walletFrom: WalletCard;
  walletTo: WalletCard;

  isPageOpened = location.pathname.includes('exchange');

  ngOnInit(): void {
    this.walletFrom = this.wallets().find(wallet => wallet.id == this.form().value['walletFromId']?.toString());
    this.walletTo = this.wallets().find(wallet => wallet.id == this.form().value['walletToId']?.toString());
  }

  getDate(): number {
    return this.now;
  }

  ngOnDestroy(): void {
    this.store.clearExchange();
    this.store.clearEstimate();
  }
}
